import React from 'react';
import styled from 'styled-components';
import {Button} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';

const Box = styled.div`
	padding: 16px;
	border: 1px dashed #c00;
	color: #c00;
`;

const PreviewErrorState: React.FC<{onRetry: () => void}> = ({onRetry}) => {
	const intl = useIntl();
	return (
		<Box>
			<div>{intl.formatMessage({id: 'quote_designer.preview.error'})}</div>
			<Button onPress={onRetry}>{intl.formatMessage({id: 'quote_designer.preview.try_again'})}</Button>
		</Box>
	);
};

export default PreviewErrorState;
